import React from "react";
import { X } from "lucide-react";

export default function FilterSidebar({
  priceRange,
  setPriceRange,
  selectedCategory,
  setSelectedCategory,
  isOpen,
  onClose,
}) {
  const categories = [
    "Indoor",
    "Outdoor",
    "Wedding",
    "Gym",
    "Office",
    "Meeting",
    "School",
    "College",
  ];

  return (
    <>
      {/* Inline CSS for animations (mobile only) */}
      <style>
        {`
          @keyframes slideIn {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(0); }
          }
          @keyframes slideOut {
            0% { transform: translateX(0); }
            100% { transform: translateX(-20%); }
          }
          .slide-in {
            animation: slideIn 0.3s ease-out forwards;
          }
          .slide-out {
            animation: slideOut 0.3s ease-out forwards;
          }
        `}
      </style>

      {/* Sidebar */}
      <div
        className={`${
          isOpen
            ? "fixed top-0 left-0 w-64 h-full md:static md:w-full slide-in md:slide-none"
            : "fixed top-0 left-0 w-64 h-full md:static md:w-full slide-out hidden md:block"
        } bg-gray-50 p-4 rounded-sm border border-gray-200 z-50 md:z-0`}
      >
        {/* Close Button (Mobile Only) */}
        <button
          onClick={onClose}
          className="md:hidden absolute top-4 right-4 text-[#333333] hover:text-[#D4AF37]"
        >
          <X className="h-6 w-6" />
        </button>

        <h3
          className="text-lg font-semibold text-[#333333] mb-4"
          style={{ fontFamily: "serif" }}
        >
          Filter Products
        </h3>

        {/* Price Range Filter */}
        <div className="mb-6">
          <h4 className="text-sm font-medium text-[#333333] mb-2">
            Price Range
          </h4>
          <div className="flex items-center gap-2">
            <input
              type="number"
              placeholder="Min"
              value={priceRange.min}
              onChange={(e) =>
                setPriceRange({ ...priceRange, min: e.target.value })
              }
              className="w-1/2 py-1 px-2 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            />
            <span className="text-gray-500">-</span>
            <input
              type="number"
              placeholder="Max"
              value={priceRange.max}
              onChange={(e) =>
                setPriceRange({ ...priceRange, max: e.target.value })
              }
              className="w-1/2 py-1 px-2 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            />
          </div>
        </div>

        {/* Category Filter */}
        <div>
          <h4 className="text-sm font-medium text-[#333333] mb-2">
            Shop Category
          </h4>
          <ul className="space-y-2">
            {categories.map((category) => (
              <li key={category}>
                <button
                  onClick={() =>
                    setSelectedCategory(
                      selectedCategory === category ? "" : category
                    )
                  }
                  className={`text-sm ${
                    selectedCategory === category
                      ? "text-[#D4AF37] font-medium"
                      : "text-gray-600 hover:text-[#D4AF37]"
                  } transition-colors duration-200`}
                >
                  {category}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Overlay (Mobile Only) */}
      {isOpen && (
        <div
          onClick={onClose}
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
        ></div>
      )}
    </>
  );
}